// extracted by mini-css-extract-plugin
module.exports = {"TopWrap":"ServicesOfferings_TopWrap__3K9ih","BottomWrap":"ServicesOfferings_BottomWrap__3MpEc","ServicesOfferings":"ServicesOfferings_ServicesOfferings__2PVL_"};